import type { TrackingInterface } from "@pdfking/pdfengine"

export const RegisteredCallbacks: TrackingInterface[] = []

export const RegisterCallbacks = (functions: TrackingInterface) =>
  RegisteredCallbacks.push(functions)
